import DataResume from "@/services/DataResume";
import { Diagnosa } from "@/types";
// import UserLogin from "@/utility/User";


import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";

export interface DiagnosaState {
  diagnosa: Diagnosa[]
}

@Module({ store, dynamic: true, name: "storeDiagnosa" })
class DiagnosaStore extends VuexModule implements DiagnosaState {
  diagnosa: Diagnosa[] = [];

  @Mutation SET_DIAGNOSA(diagnosa: Diagnosa[]) {
    this.diagnosa = diagnosa;
  }

  @Action act_diagnosa_all(term: string) {
    const dt = DataResume.getDataDiagnosa(term);
    dt.then(dt => {
      const diagnosa = dt
      // const status = dt.status
      this.SET_DIAGNOSA(diagnosa);
    });

  }


}

export const storeDiagnosa = getModule(DiagnosaStore);
